import { render, staticRenderFns } from "./button-m.vue?vue&type=template&id=dc049e38&scoped=true&"
import script from "./button-m.vue?vue&type=script&lang=js&"
export * from "./button-m.vue?vue&type=script&lang=js&"
import style0 from "./button-m.vue?vue&type=style&index=0&id=dc049e38&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc049e38",
  null
  
)

export default component.exports